const ROOT = "/appointment";

export const AppointmentRoutes = {
    ROOT,
    TOPIC: ROOT + "/topic",
    BRANCH: ROOT + "/branch",
    ADVISOR: ROOT + "/advisor",
    TIME_SLOT_DATE: ROOT + "/time-slot/date",
    TIME_SLOT: ROOT + "/time-slot",
    SUMMARY: ROOT + "/summary",
    DETAILS: ROOT + "/details",
    ERROR_NO_CALAVAIL: ROOT + "/error-no-calavail",
    ERROR_NO_BRANCH: ROOT + "/error-no-branch",
    ERROR_APPOINTMENT_NOT_AVAILABLE: ROOT + "/error-appointment-not-available",
    ERROR_ADDITIONAL_ADVISOR: ROOT + "/error-additional-advisor",
    ERROR_GENERIC: ROOT + "/error-generic",
    SUCCESS: ROOT + "/success",
    NEW_PHONE: ROOT + "/new-phone",
};



// WEBPACK FOOTER //
// ./src/components/appointment/AppointmentRoutes.ts